export default "__VITE_ASSET__fcdmBftx__"